import { Crumbs, ToolCards } from "../../components/Bits";
import { Head } from "../../components/Head";
import { TBY, TOOLS } from "../../lib/util";

export function ToolPage({ slug, h1, lead, tool, extra }) {
  const t = TBY[slug];
  const ld = [{ "@context": "https://schema.org", "@type": "WebApplication", name: t[1], description: t[3],
    applicationCategory: "UtilitiesApplication", operatingSystem: "Any", inLanguage: "da",
    offers: { "@type": "Offer", price: "0", priceCurrency: "DKK" } }];
  return (
    <>
      <Head title={h1} desc={t[3]} path={`vaerktoejer/${slug}/`} ld={ld} />
      <Crumbs trail={[["vaerktoejer/", "Værktøjer"], [null, t[1]]]} />
      <div className="wrap">
        <div className="ptop"><h1 data-testid="tool-title">{h1}</h1><p className="lead">{lead}</p></div>
        {tool}
        <div className="prose">{extra}</div>
        <div className="blk"><div className="sh"><h2>Flere værktøjer</h2></div><ToolCards tools={TOOLS.filter(x => x[0] !== slug).slice(0, 3)} /></div>
      </div>
    </>
  );
}

export function ToolsIndex() {
  return (
    <>
      <Head title="Gratis køkkenværktøjer" path="vaerktoejer/" desc="Portionsberegner, mængdeomregner, ovn til airfryer, ovntemperatur, hvor meget pr. person og madbudget. Gratis." />
      <Crumbs trail={[[null, "Værktøjer"]]} />
      <div className="wrap"><div className="ptop"><h1>Gratis værktøjer</h1>
        <p className="lead">Små værktøjer, der gør hverdagen i køkkenet lettere. Alle er gratis og kræver ingen login.</p></div>
        <ToolCards tools={TOOLS} />
        <div className="blk"><a className="tc" href="/madplan/" data-testid="tool-card-madplan"><span className="i" aria-hidden="true">🗓️</span><h3>Madplan med indkøbsliste</h3>
          <p>Planlæg ugens aftensmad, og få en samlet indkøbsliste og en anslået pris.</p></a></div>
      </div>
    </>
  );
}
